// Hooks, utils, etc.
import authService from "@lib/services/AuthService";
import permissions from "@utils/permissions";

// Types
import { DomainSettings, UserProfile } from "types/entities";

export const canSeeUpgradeButton = (
  domainSettings: DomainSettings | null,
  userProfileData: UserProfile | null,
): boolean => {
  const {
    is_in_trial: isInTrial = false,
    isFreePlan: isFreePlan = false,
    is_sandbox: isSandbox = false,
  } = domainSettings ?? {};

  const canEnableReverseTrial = userProfileData?.policies.can_enable_reverse_trial ?? false;
  const { canAccessSubscription } = permissions.accountPermissions;
  const isAdmin = authService.isAdministrator();

  return (
    !canEnableReverseTrial &&
    !isInTrial &&
    !isSandbox &&
    isFreePlan &&
    canAccessSubscription() &&
    isAdmin
  );
};
